<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee-profile pb-0">
            <div class="text-center">
                <img
                    class="wrapper_title_logo"
                    src="@/assets/home/logo-new-theme.png"
                />
            </div>
            <div class="profile-main">
                <div class="main-image-container">
                    <div v-if="line_image" class="profile-image">
                        <img :src="line_image" alt="profile-image" />
                    </div>
                    <div v-else class="profile-image-noborder">
                        <img src="@/assets/icon/default_profile.svg" />
                    </div>
                </div>
                <div class="main-top-container">
                    <div class="top-content">
                        <h4 class="name">
                            {{ profile.FirstName }} {{ profile.LastName }}
                        </h4>
                        <div class="point-bagde" style="width: fit-content">
                            <p>
                                คุณมี
                                <span class="value-coin">
                                    {{
                                        updatePoint
                                            ? numberWithCommas(updatePoint)
                                            : 0
                                    }}
                                </span>
                                คะแนน
                            </p>
                            <img src="@/assets/profile/point_dark.svg" alt="" />
                        </div>
                        <div class="expire-date" v-if="expire_point.points > 0">
                            <p>
                                {{ expirepointData }}
                            </p>
                        </div>
                        <div class="Line-18"></div>
                        <div class="profile-point">
                            <div class="tier-header">
                                <img
                                    v-if="getUserlevel.userlevel === 'gold'"
                                    class="w-100"
                                    src="@/assets/profile/profile_gold.svg"
                                    alt=""
                                />
                                <img
                                    v-else-if="
                                        getUserlevel.userlevel === 'silver'
                                    "
                                    class="w-100"
                                    src="@/assets/profile/profile_silver.svg"
                                    alt=""
                                />
                                <img
                                    v-else
                                    class="w-100"
                                    src="@/assets/profile/profile_bronze.svg"
                                    alt=""
                                />
                                <div
                                    class="benefit-btn"
                                    @click="gotopage('/benefit')"
                                >
                                    <span>
                                        {{ getUserlevel.button }}
                                    </span>
                                    <span class="arrow-image">
                                        <img
                                            src="@/assets/profile/arrow_brown.svg"
                                            alt=""
                                        />
                                    </span>
                                </div>
                            </div>
                            <div class="tier-body">
                                <div class="banner-point">
                                    คุณสะสมแล้ว
                                    <span :class="getUserlevel.userlevel">{{
                                        getUserlevel.point
                                    }}</span>
                                    แก้ว
                                </div>
                                <div class="progressbar">
                                    <div class="pointmark-container mb-1">
                                        <div class="point">
                                            {{
                                                getUserlevel.isMaintain
                                                    ? 0
                                                    : getUserlevel
                                                          .currentTierRange.from
                                            }}
                                        </div>
                                        <div
                                            class="point position-absolute"
                                            :style="calcMaintainPosition()"
                                            v-if="getUserlevel.isMaintain"
                                        >
                                            {{ getUserlevel.userLevelMaintain }}
                                        </div>
                                        <div class="point">
                                            {{
                                                getUserlevel.currentTierRange.to
                                            }}
                                        </div>
                                    </div>
                                    <div class="inactive"></div>
                                    <div
                                        class="line-image zindex1"
                                        :style="{
                                            left: progressBarCalculate(5) + '%',
                                        }"
                                    >
                                        <img
                                            :class="getUserlevel.userlevel"
                                            :src="line_image"
                                            alt=""
                                        />
                                    </div>
                                    <div
                                        class="active"
                                        :class="getUserlevel.userlevel"
                                        :style="{
                                            width: progressBarCalculate() + '%',
                                        }"
                                    ></div>
                                </div>
                                <div class="collect-point mb-1">
                                    {{ getUserlevel.title }}
                                </div>
                                <div class="tier-desc mb-1">
                                    {{ getUserlevel.date }}
                                </div>
                                <div class="tier-desc">
                                    {{ getUserlevel.desc }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="main-bottom-container">
                    <div class="bottom-content">
                        <div class="profile-item">
                            <img
                                src="@/assets/profile/cake-birthday.png"
                                alt="item-image"
                            />
                            <p class="birthdate-item">
                                {{ birthdateFormat }}
                            </p>
                        </div>
                        <div v-if="profile.ProEmail" class="profile-item">
                            <img
                                src="@/assets/profile/mail.png"
                                alt="item-image"
                            />
                            <p class="email-item">
                                {{ profile.ProEmail }}
                            </p>
                        </div>
                        <div class="profile-item">
                            <img
                                src="@/assets/profile/map-marker.png"
                                alt="item-image"
                            />
                            <p class="address-item">
                                {{ profile.Address }}
                                {{ profile.ProvinceName }}
                                {{ profile.DistrictName }}
                                {{ profile.SubDistrictName }}
                                {{ profile.Zipcode }}
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    id="profile-gotoedit-btn"
                    class="edit-profile"
                    @click="gotopage('/editprofile')"
                >
                    <span>แก้ไข</span>
                </div>
            </div>

            <div class="menu-container">
                <!--  -->
                <div
                    id="profile-gotohistorypoint-btn"
                    class="menu"
                    @click="gotopage('/historyearnpoint')"
                >
                    <p>ประวัติการสะสมคะแนน</p>
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        class="arrow-right"
                        alt="arrow-img"
                    />
                </div>
                <!--  -->
                <div
                    id="profile-gotoprivacy-btn"
                    class="menu"
                    @click="gotopage('/consenttheme')"
                >
                    <p>นโยบายความเป็นส่วนตัว</p>
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        class="arrow-right"
                        alt="arrow-img"
                    />
                </div>
                <div
                    id="profile-gotopdpa-btn"
                    class="menu"
                    @click="gotopage('/cookiepolicy')"
                >
                    <p>นโยบายคุกกี้</p>
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        class="arrow-right"
                        alt="arrow-img"
                    />
                </div>
                <div
                    id="profile-gotopdpa-btn"
                    class="menu"
                    @click="gotopage('/termstheme')"
                >
                    <p>ข้อกำหนดและเงื่อนไข</p>
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        class="arrow-right"
                        alt="arrow-img"
                    />
                </div>
                <div
                    id="profile-gotoprivacy-btn"
                    class="menu"
                    @click="gotopage('/privacysettings')"
                >
                    <p>ตั้งค่าความเป็นส่วนตัว</p>
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        class="arrow-right"
                        alt="arrow-img"
                    />
                </div>
                <!-- temporary close -->
                <div
                    id="profile-gotohistorypurchase-btn"
                    class="menu"
                    @click="gotopage('/order')"
                >
                    <p>ประวัติคำสั่งซื้อ</p>
                    <img
                        src="@/assets/profile/arrow_white.svg"
                        class="arrow-right"
                        alt="arrow-img"
                    />
                </div>
            </div>
            <div class="row footer-profile mb-4">
                <div class="col-6">
                    <div class="cancel-container">
                        <p
                            id="profile-gotoinactiveuser-btn"
                            @click="showCancelModal()"
                        >
                            ยกเลิกการเป็นสมาชิก
                        </p>
                    </div>
                </div>
                <div class="col-6">
                    <div class="logo-profile">
                        <img
                            class="bzb_logo_profile"
                            src="../../../assets/icon/bzb_logo_profile_new.svg"
                        />
                    </div>
                </div>
            </div>
            <ModalMaster :controller="modalController"></ModalMaster>
            <Footer :settabactive="'profile'" />
        </div>
    </div>
</template>
<script>
// import Vue from 'vue';
import Locale from "@/helper/locale/locale.js";
import _ from "lodash";
import moment from "moment";
//component
import Footer from "@/components/Footer/Footer.vue";
//helper
import CacheHelper from "@/helper/CacheHelper.js";
import DatetimeHelper from "@/helper/DatetimeHelper";
//service
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
// import MenuApi from "@/module/Menu/service/missionbadge.js";
//mixin
import Mixin from "@/mixin/Mixin";
import ModalMixin from "@/mixin/ModalMixin.js";
import CheckLogin from "@/mixin/CheckLogin.js";
//vuex
import { mapGetters, mapActions } from "vuex";

export default {
    name: "register",
    components: {
        Footer,
    },
    mixins: [Mixin, CheckLogin, ModalMixin],
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            lbl: Locale.getLbl(),
            profile: {},
            line_image: null,
            birthdateFormat: "",
            profile_expire: "",
            expire_point: { points: 0, time: null },
            link: {
                waterdelivery: "",
                Shopyangpro: "",
            },

            //in case, don't get data from store
            configData: {
                userlevel: "",
                point: "",
                gold: "",
                silver: "",
                desc: "",
                button: "",
            },
            profileuser: {},
            updatePoint: 0,
        };
    },
    beforeCreate: function () {},
    created: async function () {
        this.handleLoading(true);
        this.line_image = this.cacheHelper.getCache("BzbsUser").line.pictureUrl;
        await this.getProfile();
        this.getGlassPoint(),
            Promise.all([
                this.getProfileSSO(),
                this.getExpirePointDate(),
                this.getProfile(),
                this.getExpirePoint(),
                this.getGlassPoint(),
                this.getBlob(),
                this.checkGlass(),
            ]).then(() => {
                this.handleLoading(false);
            });
    },
    computed: {
        ...mapGetters(["getUserlevel"]),
        expirepointData() {
            return this.profile_expire
                .replace("x", this.expire_point.points)
                .replace("y", this.expire_point.time);
        },
    },
    methods: {
        ...mapActions(["setUserlevel"]),
        getBlob() {
            const url =
                "/nestle/nescafe_streetcafe/custom/nescafe_streetcafe_content.json";
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then((response) => {
                        // console.log(response)
                        this.profile_expire = response.profile_expire;
                        this.cancelModal.setData({
                            title: response.inactive_user.modal_one.strHeadLine,
                            nescafe:
                                response.inactive_user.modal_one.streetChoice,
                            all: response.inactive_user.modal_one.allChoice,
                            nestleList:
                                response.inactive_user.modal_one.allNestle,
                            message: response.inactive_user.modal_one.strMesage,
                            btnKeep: response.inactive_user.modal_one.btn_ok,
                            btnNotKeep:
                                response.inactive_user.modal_one.btn_cancel,
                        });
                        this.confirmModal.setData({
                            title: response.inactive_user.modal_two.strHeadLine,
                            msg: response.inactive_user.modal_two.strMesage,
                            msgAll: response.inactive_user.modal_two
                                .strMesageAll,
                            btnOk: response.inactive_user.modal_two.btn_ok,
                            btnCancel:
                                response.inactive_user.modal_two.btn_cancel,
                        });
                        this.alertModal.setTitle(
                            response.inactive_user.modal_fail.strHeadLine
                        );
                        this.alertModal.setMsg(
                            response.inactive_user.modal_fail.strMesage
                        );
                        this.alertModal.setBtnOk(
                            response.inactive_user.modal_fail.btn_ok
                        );
                        this.link.waterdelivery =
                            response.inactive_user.modal_fail.waterdelivery;
                        this.link.Shopyangpro =
                            response.inactive_user.modal_fail.Shopyangpro;
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        telNumber(tel) {
            if (_.isEmpty(tel)) return;
            var x = tel.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            return !x[2]
                ? x[1]
                : "" + x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        },
        getProfileSSO() {
            return new Promise((resolve) => {
                BzbsApi.getProfileSSO(
                    this.cacheHelper.getCache("BzbsUser").token
                ).then((response) => {
                    this.profile = response.data.SSOUser;
                    if (this.profile.Birthdate != null) {
                        this.setbirthdate(this.profile.Birthdate);
                    }
                    resolve(this.profile);
                });
            });
        },
        getExpirePointDate() {
            BzbsApi.getExpirePointDate(
                this.cacheHelper.getCache("BzbsUser").token
            ).then((response) => {
                let expiredata = response.data.expiring_points;
                this.expire_point.points = expiredata.points;
                this.expire_point.time = DatetimeHelper.dateFullFormat(
                    expiredata.time
                );
            });
        },
        setbirthdate(Birthdate) {
            this.birthdateFormat = moment
                .unix(Birthdate)
                .utc()
                .add(543, "year")
                .format("DD MMMM YYYY");
        },
        getExpirePoint() {
            return new Promise((resolve) => {
                BzbsApi.getExpirePoint(
                    this.cacheHelper.getCache("BzbsUser").token
                ).then((response) => {
                    if (response.data.expiring_points[0]) {
                        this.expire_point.points =
                            response.data.expiring_points[0].points;
                        this.expire_point.time = moment
                            .unix(response.data.expiring_points[0].time)
                            .utc()
                            .add(543, "year")
                            .format("DD MMMM YYYY");
                    }
                    resolve(response);
                });
            });
        },
        showCancelModal() {
            this.cancelModal.show();
            this.cancelModal.clickKeep((data) => {
                this.confirmModal.show(data);
            });
            this.confirmModal.onError((data) => {
                if (data === "Shopyangpro") {
                    this.alertModal.setLink(this.link.Shopyangpro);
                } else if (data === "waterdelivery") {
                    this.alertModal.setLink(this.link.waterdelivery);
                } else {
                    this.alertModal.setLink(window.location.origin);
                }
                this.alertModal.show(data);
            });
        },
        numberWithCommas(x) {
            if (x) {
                return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else if (x == 0) {
                return 0;
            } else {
                return "-";
            }
        },
        gotopage(path) {
            this.$router.push(path);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/module/Profile/style/profile.scss";
.benefit-btn {
    text-align: center;
    font-family: Prompt;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
    position: absolute;
    top: 18px;
    right: 15px;
}

.line-image {
    position: absolute;
    transform: translate(-50%, 0%);
    top: 8px;
    img {
        border-radius: 15px;
        height: 16px;
        &.bronze {
            border: solid 2px #a7907b;
        }
        &.silver {
            border: solid 2px #51504f;
        }
        &.gold {
            border: solid 2px #a27939;
        }
    }
}
.arrow-right {
    width: 24px;
    height: 24px;
}
</style>
